import { render, staticRenderFns } from "./transmitFileType.vue?vue&type=template&id=081f4a2a&"
import script from "./transmitFileType.vue?vue&type=script&lang=js&"
export * from "./transmitFileType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('081f4a2a')) {
      api.createRecord('081f4a2a', component.options)
    } else {
      api.reload('081f4a2a', component.options)
    }
    module.hot.accept("./transmitFileType.vue?vue&type=template&id=081f4a2a&", function () {
      api.rerender('081f4a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/components/basicData/transmitFileType.vue"
export default component.exports